import React, { useState, useEffect } from "react";
import { Col, Form, Row, Tab, Tabs } from "react-bootstrap";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import {
  dateFormat,
  isAdmin,
  refreshPage,
  selectDropdownStyle,
  toastStyle,
} from "../../Helpers/Utils/Common";
import {
  deleteTransfer,
  updateTransferStatus,
} from "../../Helpers/apiCalls/Inventory/TransferApi";

import DeleteModal from "../../Components/Modals/DeleteModal";
import Navbar from "../../Components/Navbar/Navbar";
import Table from "../../Components/TableTemplate/Table";
import TransferModal from "./Transfer/TransferModal";

import toast from "react-hot-toast";
import { getAllBranches } from "../../Helpers/apiCalls/Manage/Branches";

import "./Inventory.css";
import Moment from "moment";

export default function IncomingTransfers() {
  let navigate = useNavigate();
  const [inactive, setInactive] = useState(true);

  /* delete modal handler */
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const handleShowDeleteModal = () => setShowDeleteModal(true);
  const handleCloseDeleteModal = () => setShowDeleteModal(false);
  const [transferId, setTransferId] = useState("");
  const [branches, setBranches] = useState([]);
  const [branchOptions, setBranchOptions] = useState([]);
  const [isClicked, setIsClicked] = useState(false);

  useEffect(() => {
    setBranchOptions([
      { label: "All Branches", value: "" },
      ...branches.map((_branch) => {
        var retval = { label: _branch.name, value: _branch.id };
        return retval;
      }),
    ]);
  }, [branches]);

  function handleBranchFromChange(e) {
    const toFilter = { target: { name: "branch_from", value: e.value } };
    handleFilterChange(toFilter);
  }

  function handleBranchToChange(e) {
    const toFilter = { target: { name: "branch_to", value: e.value } };
    handleFilterChange(toFilter);
  }

  /** POST API - UPDATE TRANSFER STATUS TO DELETE **/
  async function handleDeleteTransfer() {
    setIsClicked(true);
    const cash = await deleteTransfer(transferId);
    if (cash.data.response === "Transfer deleted successfully.") {
      toast.success("Transfer deleted successfully", {
        style: toastStyle(),
      });
      setTimeout(() => {
        handleCloseDeleteModal();
        // refreshPage();
      }, 1000);
    } else {
      toast.error(cash.data.response, {
        style: toastStyle(),
      });
      handleCloseDeleteModal();
      // refreshPage();
    }
  }

  async function handleRequestTransfer() {
    const cash = await updateTransferStatus(transferId, "Requested");
    if (cash.data.response === "Status changed successfully") {
      toast.success("Transfer moved to for Approval", {
        style: toastStyle(),
      });
      setTimeout(() => {
        handleCloseApproveModal();
        refreshPage();
      }, 1000);
    } else {
      toast.error(cash.data.response, {
        style: toastStyle(),
      });
      handleCloseApproveModal();
    }
  }

  async function fetchBranchesFilter() {
    setShowLoader(true);

    const response = await getAllBranches();
    if (response.error) {
    } else {
      var allBranches = response.data.data.data.map((data) => {
        var branch = data;
        return branch;
      });
      setBranches(allBranches);
    }
    setShowLoader(false);
  }

  async function handleSelectChange(e, idno, id, status) {
    switch (e.target.value) {
      case "edit-po":
        navigate("edit/" + id + "/" + status);
        break;

      case "delete-po":
        handleShowDeleteModal();
        setTransferId(idno);
        break;

      case "return-po":
        handleShowApproveModal();
        setTransferId(idno);

        break;

      case "print-po":
        navigate("print/" + id);
        break;

      case "review-po":
        window.open("/transfers/view/" + id + "/" + status, "_blank");
        break;

      case "view-po":
        navigate("view/" + id + "/" + status);
        break;

      default:
        break;
    }
  }

  
  const [showLoader, setShowLoader] = useState(false);

  /* Approve Modal */
  const [showApproveModal, setShowApproveModal] = useState(false);
  const handleShowApproveModal = () => setShowApproveModal(true);
  const handleCloseApproveModal = () => setShowApproveModal(false);

  const [transferManager, setTransferManager] = useState([]);
  const [filterConfig, setFilterConfig] = useState({
    tab: "requested",
    status: "requested",
    // transfer_status: "requested",
    shop_type: "",
    branch_to: "",
    transfer_number: "",
  });

  const handleTabSelect = (tabKey) => {
    if (tabKey === "") {
      setFilterConfig((prev) => {
        return {
          ...prev,
          tab: "",
          status: "",
          transfer_status: "",
          branch_from: "",
          branch_to: "",
        };
      });
    } else if (tabKey === "completed" || tabKey === "incomplete") {
      setFilterConfig((prev) => {
        return {
          ...prev,
          tab: tabKey,
          status: tabKey,
          branch_from: "",
          branch_to: "",
        };
      });
    } else if (tabKey === "requested") {
      setFilterConfig((prev) => {
        return {
          ...prev,
          tab: tabKey,
          // transfer_status: tabKey,
          status: "requested",
          branch_from: "",
          branch_to: "",
        };
      });
    } else {
      setFilterConfig((prev) => {
        return {
          ...prev,
          tab: tabKey,
          status: tabKey,
          branch_from: "",
          branch_to: "",
        };
      });
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilterConfig((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  React.useEffect(() => {
    searchTransfers(filterConfig);
  }, [filterConfig]);


  async function searchTransfers(filterConfig) {
    setShowLoader(true);
    setTransferManager([]);
    var allData = [];

    const response = await searchTransfers(filterConfig);

    if (response.data) {
        response.data.data.map(async (transfer) => {
            var info = {};

            info.id = transfer.id;
            info.status = transfer.status;
            info.transfer_date = Moment(transfer.transfer_date).format("MM-DD-YYYY");
            info.date_received = transfer.completed_on
                ? Moment(transfer.completed_on).format("MM-DD-YYYY")
                : "";
            info.added_on = Moment(transfer.added_on).format("MM-DD-YYYY");
            info.added_by = transfer.added_by_name;
            info.transfer_number = transfer.transfer_number;
            info.doc_no = transfer.id;
            info.branch_from = transfer.branch_from;
            info.branch_from_name = transfer.branch_from_name;
            info.branch_to = transfer.branch_to;
            info.branch_to_name = transfer.branch_to_name;
            info.completed_by = transfer.completed_by_name;
            info.approved_by = transfer.approved_by_name;
            info.shop_type = "";
            allData.push(info);
            return info;
        });
    } 

    var braddexTransfers = allData
            .sort((a, b) =>
            new Date(...a.transfer_date?.split('/').reverse()) - new Date(...b.transfer_date?.split('/').reverse())
        ).reverse()
        .map((transfer) => {
            var info = transfer;
            info.added_on = dateFormat(transfer.added_on);
            return info;
        });
    setTransferManager(braddexTransfers);
    setShowLoader(false);
}

  function ReviewTransfer(row) {
    return (
      <button
        type="button"
        className="button-primary view-btn me-3"
        onClick={() => handleReviewTransfer(row.doc_no, row.status)}
      >
        View
      </button>
    );
  }

  function handleReviewTransfer(id, transfer_status) {
    window.open("/transfers/view/" + id + "/" + transfer_status, "_blank");
  }

  function ViewTransfer(row) {
    return (
      <button
        type="button"
        className="btn btn-sm view-btn-table"
        onClick={() => handleViewTransfer(row.doc_no, row.status)}
      >
        Review
      </button>
    );
  }

  function handleViewTransfer(id, transfer_status) {
    window.open("/transfers/view/" + id + "/" + transfer_status, "_blank");
  }

  function ActionBtn(row, type) {
    return (
      <Form.Select
        name="action"
        className="PO-select-action"
        id={row.id}
        onChange={(e) => handleSelectChange(e, row.id, row.doc_no, row.status)}
      >
        <option value="" selected hidden>
          Select
        </option>

        {type === "deleted" ? (
          <>
            <option value="view-po" className="color-options">
              View
            </option>
            <option value="return-po" className="color-options">
              Return to Requested
            </option>
          </>
        ) : (
          <>
            {type === "approved" ? (
              <>
                <option value="print-po" className="color-options">
                  {type.includes("printed") ? "Reprint" : "Print"}
                </option>
                <option value="send-po" className="color-options">
                  Send to Supplier
                </option>
                <option value="email-po" className="color-options">
                  Email to Supplier
                </option>
                <option value="return-po" className="color-yellow">
                  Return to Pending
                </option>
              </>
            ) : (
              <>
                {type === "processed" ? (
                  <>
                    <option value="view-po" className="color-options">
                      View
                    </option>
                    {isAdmin && (
                      <option value="delete-po" className="color-red">
                        Delete
                      </option>
                    )}
                  </>
                ) : (
                  <>
                    {type === "disapproved" ? (
                      <option value="return-po" className="color-yellow">
                        Return to Pending
                      </option>
                    ) : (
                      <>
                        {type === "all" && (
                          <>
                            <option value="view-po" className="color-options">
                              View
                            </option>
                            {isAdmin() && (
                              <option value="delete-po" className="color-red">
                                Delete
                              </option>
                            )}
                          </>
                        )}
                      </>
                    )}
                  </>
                )}{" "}
                :{" "}
                {type === "requested" ? (
                  <>
                    <option value="review-po" className="color-options">
                      Review
                    </option>
                    {isAdmin() && (
                      <option value="delete-po" className="color-red">
                        Delete
                      </option>
                    )}
                  </>
                ) : (
                  <></>
                )}
              </>
            )}
          </>
        )}
      </Form.Select>
    );
  }

  React.useEffect(() => {
    fetchBranchesFilter();
  }, []);

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive);
          }}
          active={"TRANSFERS"}
        />
      </div>

      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        {/* headers */}
        <Row className="mb-4">
          <Col xs={6}>
            <h1 className="page-title"> INCOMING TRANSFERS </h1>
          </Col>
          <Col xs={6} className="d-flex justify-content-end">
            <input
              type="text"
              name="transfer_number"
              className="search-bar"
              placeholder="Search transfer number..."
              onKeyPress={(e) =>
                e.key === ("Enter" || "NumpadEnter") && handleFilterChange(e)
              }
            />

            <button
              className="add-btn"
              onClick={() => navigate("/transfers/add")}
            >
              Add
            </button>
          </Col>
        </Row>

        {/* tabs */}
        <Tabs
          activeKey={filterConfig.tab}
          defaultActiveKey={filterConfig.tab}
          id="PO-tabs"
          onSelect={handleTabSelect}
        >
          <Tab eventKey="requested" title="for approval">
            {/* filters */}
            <div className="my-2 px-4 PO-filters d-flex">
              <span className="me-4 align-middle mt-2">Filter By:</span>

              <Select
                className="dropsearch-filter px-0 py-0 me-2"
                classNamePrefix="react-select"
                placeholder={"Branch From"}
                styles={selectDropdownStyle}
                // value={branchFrom}
                options={branchOptions}
                onChange={handleBranchFromChange}
              />
              <Select
                className="dropsearch-filter px-0 py-0 me-2"
                classNamePrefix="react-select"
                placeholder="Branch To"
                styles={selectDropdownStyle}
                // value={branchTo}
                options={branchOptions}
                onChange={handleBranchToChange}
              />

              <span className="me-4 align-middle mt-2">Date From:</span>
              <Form.Control
                type="date"
                name="transfer_date_from"
                className="date-filter me-3"
                onChange={handleFilterChange}
                value={filterConfig.transfer_date_from}
              />

              <span className="me-4 align-middle mt-2">To:</span>
              <Form.Control
                type="date"
                name="transfer_date_to"
                className="date-filter me-3"
                onChange={handleFilterChange}
                value={filterConfig.transfer_date_to}
              />
            </div>

            {/* table */}
            <Table
              tableHeaders={[
                "-",
                "TRANSFER DATE",
                "FROM",
                "TO",
                "TRANS NO.",
                "STATUS",
                "ENCODED BY",
                "APPROVED BY",
                "DOC NO.",
                "ACTIONS",
              ]}
              headerSelector={[
                "-",
                "transfer_date",
                "branch_from_name",
                "branch_to_name",
                "transfer_number",
                "status",
                "added_by",
                "approved_by",
                "doc_no",
                "-",
              ]}
              tableData={transferManager}
              ActionBtn={(row) => ActionBtn(row, row.status)}
              ViewBtn={(row) => ViewTransfer(row)}
              showLoader={showLoader}
            />
            <div className="mb-2" />
          </Tab>

          <Tab eventKey="processed,for_adjustment" title="processed">
            {/* filters */}
            <div className="my-2 px-4 PO-filters d-flex">
              <span className="me-4 align-middle mt-2">Filter By:</span>

              <Select
                className="dropsearch-filter px-0 py-0 me-2"
                classNamePrefix="react-select"
                placeholder={"Branch From"}
                styles={selectDropdownStyle}
                // value={branchFrom}
                options={branchOptions}
                onChange={handleBranchFromChange}
              />
              <Select
                className="dropsearch-filter px-0 py-0 me-2"
                classNamePrefix="react-select"
                placeholder="Branch To"
                styles={selectDropdownStyle}
                // value={branchTo}
                options={branchOptions}
                onChange={handleBranchToChange}
              />

              <span className="me-4 align-middle mt-2">Date From:</span>
              <Form.Control
                type="date"
                name="transfer_date_from"
                className="date-filter me-3"
                onChange={handleFilterChange}
                value={filterConfig.transfer_date_from}
              />

              <span className="me-4 align-middle mt-2">To:</span>
              <Form.Control
                type="date"
                name="transfer_date_to"
                className="date-filter me-3"
                onChange={handleFilterChange}
                value={filterConfig.transfer_date_to}
              />
            </div>

            {/* table */}
            <Table
              tableHeaders={[
                "-",
                "DATE TRANSFERRED",
                "DATE RECEIVED",
                "ENCODED ON",
                "TRANSFER NO.",
                "DOC NO.",
                "TO",
                "STATUS",
                "APRVD BY",
                "ACTIONS",
              ]}
              headerSelector={[
                "-",
                "transfer_date",
                "date_received",
                "added_on",
                "transfer_number",
                "doc_no",
                "branch_to_name",
                "status",
                "approved_by",
              ]}
              tableData={transferManager}
              ActionBtn={(row) => ActionBtn(row, row.status)}
              ViewBtn={(row) => ReviewTransfer(row)}
              showLoader={showLoader}
            />
            <div className="mb-2" />
          </Tab>

          <Tab eventKey="completed" title="completed">
            {/* filters */}
            <div className="my-2 px-4 PO-filters d-flex">
              <span className="me-4 align-middle mt-2">Filter By:</span>

              <Select
                className="dropsearch-filter px-0 py-0 me-2"
                classNamePrefix="react-select"
                placeholder={"Branch From"}
                styles={selectDropdownStyle}
                // value={branchFrom}
                options={branchOptions}
                onChange={handleBranchFromChange}
              />

              <Select
                className="dropsearch-filter px-0 py-0 me-2"
                classNamePrefix="react-select"
                placeholder="Branch To"
                styles={selectDropdownStyle}
                // value={branchTo}
                options={branchOptions}
                onChange={handleBranchToChange}
              />

              <span className="me-4 align-middle mt-2">Date From:</span>
              <Form.Control
                type="date"
                name="transfer_date_from"
                onChange={handleFilterChange}
                value={filterConfig.transfer_date_from}
                className="date-filter me-3"
              />

              <span className="me-4 align-middle mt-2">To:</span>
              <Form.Control
                type="date"
                name="transfer_date_to"
                onChange={handleFilterChange}
                value={filterConfig.transfer_date_to}
                className="date-filter me-3"
              />
            </div>

            {/* table */}
            <Table
              tableHeaders={[
                "-",
                "TRANSFER DATE",
                "FROM",
                "TO",
                "TRANS NO.",
                "STATUS",
                "ENCODED BY",
                "APPROVED BY",
                "DOC NO.",
              ]}
              headerSelector={[
                "-",
                "transfer_date",
                "branch_from_name",
                "branch_to_name",
                "transfer_number",
                "status",
                "added_by",
                "approved_by",
                "doc_no",
              ]}
              tableData={transferManager}
              ViewBtn={(row) => ReviewTransfer(row)}
              showLoader={showLoader}
            />
            <div className="mb-2" />
          </Tab>

          <Tab eventKey="" title="all" className="manager-tabs">
            {/* filters */}
            <div className="my-2 px-4 PO-filters d-flex">
              <span className="me-4 align-middle mt-2">Filter By:</span>

              <Select
                className="dropsearch-filter px-0 py-0 me-2"
                classNamePrefix="react-select"
                placeholder={"Branch From"}
                styles={selectDropdownStyle}
                // value={branchFrom}
                options={branchOptions}
                onChange={handleBranchFromChange}
              />
              <Select
                className="dropsearch-filter px-0 py-0 me-2"
                classNamePrefix="react-select"
                placeholder="Branch To"
                styles={selectDropdownStyle}
                // value={branchTo}
                options={branchOptions}
                onChange={handleBranchToChange}
              />

              <span className="me-4 align-middle mt-2">Date From:</span>
              <Form.Control
                type="date"
                name="transfer_date_from"
                value={filterConfig.transfer_date_from}
                onChange={handleFilterChange}
                className="date-filter me-3"
              />

              <span className="me-4 align-middle mt-2">To:</span>
              <Form.Control
                type="date"
                name="transfer_date_to"
                value={filterConfig.transfer_date_to}
                onChange={handleFilterChange}
                className="date-filter me-3"
              />
            </div>

            {/* table */}
            <Table
              tableHeaders={[
                "-",
                "TRANSFER DATE",
                "FROM",
                "TO",
                "TRANS NO.",
                "STATUS",
                "ENCODED BY",
                "APPROVED BY",
                "DOC NO.",
                "ACTIONS",
              ]}
              headerSelector={[
                "-",
                "transfer_date",
                "branch_from_name",
                "branch_to_name",
                "transfer_number",
                "status",
                "added_by",
                "approved_by",
                "doc_no",
                "-",
              ]}
              tableData={transferManager}
              ActionBtn={(row) => ActionBtn(row, "all")}
              showLoader={showLoader}
            />
            <div className="mb-2" />
          </Tab>

          <Tab eventKey="deleted" title="deleted">
            {/* filters */}
            <div className="my-2 px-4 PO-filters d-flex">
              <span className="me-4 align-middle mt-2">Filter By:</span>

              <Select
                className="dropsearch-filter px-0 py-0 me-2"
                classNamePrefix="react-select"
                placeholder={"Branch From"}
                styles={selectDropdownStyle}
                // value={branchFrom}
                options={branchOptions}
                onChange={handleBranchFromChange}
              />
              <Select
                className="dropsearch-filter px-0 py-0 me-2"
                classNamePrefix="react-select"
                placeholder="Branch To"
                styles={selectDropdownStyle}
                // value={branchTo}
                options={branchOptions}
                onChange={handleBranchToChange}
              />

              <span className="me-4 align-middle mt-2">Date From:</span>
              <Form.Control
                type="date"
                name="transfer_date_from"
                onChange={handleFilterChange}
                value={filterConfig.transfer_date_from}
                className="date-filter me-3"
              />

              <span className="me-4 align-middle mt-2">To:</span>
              <Form.Control
                type="date"
                name="transfer_date_to"
                onChange={handleFilterChange}
                value={filterConfig.transfer_date_to}
                className="date-filter me-3"
              />
            </div>

            {/* table */}
            <Table
              tableHeaders={[
                "-",
                "TRANSFER DATE",
                "FROM",
                "TO",
                "TRANS NO.",
                "STATUS",
                "ENCODED BY",
                "APPROVED BY",
                "DOC NO.",
              ]}
              headerSelector={[
                "-",
                "transfer_date",
                "branch_from_name",
                "branch_to_name",
                "transfer_number",
                "status",
                "added_by",
                "approved_by",
                "doc_no",
              ]}
              tableData={transferManager}
              ActionBtn={(row) => ActionBtn(row, row.status)}
              showLoader={showLoader}
            />
            <div className="mb-2" />
          </Tab>
        </Tabs>
      </div>

      {/* modals */}
      <DeleteModal
        show={showDeleteModal}
        onHide={() => handleCloseDeleteModal()}
        text="transfer"
        onDelete={() => handleDeleteTransfer()}
        isClicked={isClicked}
      />
      <TransferModal
        show={showApproveModal}
        hide={handleCloseApproveModal}
        type="Return to Request"
        handler={handleRequestTransfer}
      />
    </div>
  );
}
